<app-page-title icon="fa-mobile" title="Relatório de Acessos ao APP"></app-page-title>

<div class="app-auth-report">
  <section class="filters-bar">
    <div class="filters-row">
      <div class="filter-field">
        <mat-form-field appearance="fill">
          <mat-label>Data início</mat-label>
          <input
            matInput
            [matDatepicker]="pickerStart"
            [(ngModel)]="startDate"
            name="startDate"
          />
          <mat-datepicker-toggle matIconSuffix [for]="pickerStart"></mat-datepicker-toggle>
          <mat-datepicker #pickerStart></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="filter-field">
        <mat-form-field appearance="fill">
          <mat-label>Data fim</mat-label>
          <input
            matInput
            [matDatepicker]="pickerEnd"
            [(ngModel)]="endDate"
            name="endDate"
          />
          <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
          <mat-datepicker #pickerEnd></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="filter-field">
        <mat-form-field appearance="fill">
          <mat-label>E-mail</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="filterEmail"
            name="email"
            placeholder="Buscar por e-mail"
          />
        </mat-form-field>
      </div>

      <div class="filter-actions">
        <button class="btn btn-primary" type="button" (click)="filter()" [disabled]="loading">
          <i class="fa fa-search"></i> Filtrar
        </button>
        <button class="btn btn-outline-secondary" type="button" (click)="clear()" [disabled]="loading">
          Limpar
        </button>
      </div>
    </div>
  </section>

  <!-- Ver o comentário do relatório de provedores: totais em cima, tabela
       embaixo, e um rótulo só para não anunciar duas vezes. -->
  <div *ngIf="loading" data-testid="app-authentication-report-loading">
    <app-skeleton variant="card" [count]="3" label="Carregando o relatório de acessos"></app-skeleton>
    <app-skeleton variant="table-row" [count]="8" [columns]="5" label=""></app-skeleton>
  </div>

  <ng-container *ngIf="!loading">
    <div *ngIf="items.length > 0" class="totals-row">
      <div class="total-card primary">
        <div class="total-card-label">Acessos via APP</div>
        <div class="total-card-value">{{ total | numberFormat }}</div>
        <div class="total-card-sub">
          <i class="fa fa-mobile"></i> No período filtrado
        </div>
      </div>

      <div class="total-card">
        <div class="total-card-label">Exibindo</div>
        <div class="total-card-value">{{ items.length }}</div>
        <div class="total-card-sub">
          <i class="fa fa-list"></i> Página {{ currentPage }} de {{ totalPages }}
        </div>
      </div>
    </div>

    <ng-container *ngIf="items.length > 0; else noData">
      <div class="report-card">
        <table class="access-table">
          <thead>
            <tr>
              <th>E-mail da conta</th>
              <th>Horário de login</th>
              <th>Versão do app</th>
              <th>Device ID</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items; trackBy: trackById">
              <td class="cell-email">{{ item.email }}</td>
              <td class="cell-date">{{ item.created_at | date:'dd/MM/yyyy HH:mm:ss' }}</td>
              <td class="cell-ua" [title]="item.user_agent">{{ item.user_agent }}</td>
              <td class="cell-device">{{ item.device_id || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <app-pagination
        *ngIf="total > perPage"
        class="pagination-bar"
        [currentPage]="currentPage"
        [itemsPerPage]="perPage"
        [totalItems]="total"
        (pageChanged)="onPageChange($event)"
      ></app-pagination>
    </ng-container>

    <ng-template #noData>
      <div class="empty-state">
        Nenhum acesso via APP encontrado para os filtros informados.
      </div>
    </ng-template>
  </ng-container>
</div>
